import apiClient from '../Okta/axiosInterceptor';
export const generateAiInsights = async (
  data,
  isManager,
  module,
  signal,
  roleMapped
) => {
  try {
    const payload = {
      persona_name: 'leadership',
      project_name: 'SpendWise',
      module_name: module,
      rbac_okta: {
        pepappspendwisesectors: data?.pepappspendwisesectors,
        pepappspendwisecategories: data?.pepappspendwisecategories,
        pepappspendwiseroles: roleMapped ?? data?.pepappspendwiseroles ?? [],
        email: data?.email,
        username: data?.displayname,
      },
      gpid: data?.gpid,
      source: 'spendwiseui',
      is_manager: isManager,
    };
    const response = await apiClient.post(
      `${process.env.REACT_APP_DWDGPT_API}/insights/generate-response`,
      payload,
      {signal: signal}
    );
    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};
